import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { isPrivateChallenge } from '../../../selectors/isPrivateChallenge';
import { isLoggedInUser } from '../../../contexts/User/helpers/userContextHelpers';

export function needToRedirectToLogin({
  initialProps,
  flowAPI,
}: {
  initialProps: any;
  flowAPI: ControllerFlowAPI;
}) {
  const challenge = initialProps?.challengeData?.challenge;
  if (isPrivateChallenge(challenge) && !isLoggedInUser(flowAPI)) {
    return true;
  }

  return false;
}
